import React from "react";
import ReactDOM from "react-dom";

class AddToCart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      savingInProgress: false,
      completedSave: false,
    };
    this.onClickCart = this.onClickCart.bind(this);
    this.saveShopifyLineItem = this.saveShopifyLineItem.bind(this);
    this.getCartCookie = this.getCartCookie.bind(this);
    this.saveSuccess = this.saveSuccess.bind(this);
  }

  componentDidMount() {
    if (this.props.auto_start) {
      this.onClickCart();
    }
  }

  onClickCart() {
    this.setState({ savingInProgress: true });
    this.saveShopifyLineItem();
  }

  getCartCookie() {
    let a = `; ${document.cookie}`.match(`;\\s*cart=([^;]+)`);
    if (a) {
      console.log("Cart Cookie Found :)");
      return a[1].slice(-10);
    } else {
      console.log("Getting Cookie via cart.json");
      $.ajax({
        method: "GET",
        url: window.Shopify.routes.root + "cart.json",
      }).done(function (data) {
        return data.token.slice(-10);
      });
    }
  }

  saveShopifyLineItem() {
    let shopifyData = {
      items: [
        {
          id: this.props.shopify_variant_id,
          quantity: 1,
          properties: this.props.shopify_properties,
        },
      ],
    };

    console.log(shopifyData);

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(shopifyData),
    })
      .then((response) => {
        if (response.ok) {
          console.log("SAVED TO SHOPIFY");
          this.saveOrderItem();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  saveOrderItem() {
    let cart_id;
    cart_id = this.getCartCookie();

    let draftOrderItem = {
      shopify_cart_id: cart_id,
      draft_order_item: {
        productable_id: this.props.productable_id,
        productable_type: this.props.productable_type,
      },
    };

    console.log(draftOrderItem);

    $.ajax({
      method: "POST",
      url: this.props.draft_order_items_path,
      data: draftOrderItem,
    })
      .done(this.saveSuccess)
      .fail(this.saveFail);
  }

  saveSuccess(data) {
    console.log(data);
    console.log("DONE!!!");
    this.setState({ savingInProgress: false, completedSave: true });

    if (this.props.redirect_cart) {
      window.location.href = window.Shopify.routes.root + "cart";
    }
  }

  saveFail(data) {
    console.log(data);
    this.setState({ savingInProgress: false });
    console.log(data.responseJSON.error);
    this.setState({ error: data.responseJSON.error });
  }

  render() {
    return (
      <div className="f">
        <button
          type="button"
          disabled={this.state.savingInProgress || this.state.completedSave}
          onClick={this.onClickCart}
          className="btn btn-primary btn-sm disabled:bg-stone-400 disabled:border-stone-400 disabled:text-white disabled:cursor-not-allowed"
        >
          {this.state.savingInProgress && (
            <i className="fa-solid fa-spinner fa-spin mr-2"></i>
          )}
          {this.state.completedSave && (
            <i className="fa-solid fa-check mr-2"></i>
          )}
          {!this.state.completedSave ? "Add to cart" : "Added!"}
        </button>
      </div>
    );
  }
}

export default AddToCart;
